import React from 'react';

interface Props {
  size: number;
}

const AlertIcon = (props: Props) => {
  const { size } = props;
  return (

    <svg width={size} height={size} viewBox="0 0 220 220" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.997" fillRule="evenodd" clipRule="evenodd" d="M123.291 43.7012C128.999 43.5036 133.637 45.6195 137.207 50.0488C161.295 91.7153 185.384 133.382 209.473 175.049C214.557 183.534 213.499 191.103 206.299 197.754C204.192 199.053 201.914 199.867 199.463 200.195C149.658 200.521 99.8535 200.521 50.0488 200.195C40.2676 197.97 35.9545 191.866 37.1094 181.885C37.8141 179.498 38.7907 177.219 40.0391 175.049C64.1274 133.382 88.2163 91.7153 112.305 50.0488C115.181 46.4576 118.843 44.3417 123.291 43.7012Z" fill="#EE404C" />
      <path fillRule="evenodd" clipRule="evenodd" d="M121.338 90.5762C124.78 90.1943 128.035 90.7642 131.104 92.2852C132.178 93.376 133.073 94.5967 133.789 95.9473C134.115 111.084 134.115 126.221 133.789 141.357C133.039 144.711 131.005 146.746 127.686 147.461C121.709 149.072 117.722 147.038 115.723 141.357C115.397 126.221 115.397 111.084 115.723 95.9473C116.913 93.3721 118.785 91.582 121.338 90.5762Z" fill="#FEF6EC" />
      <path fillRule="evenodd" clipRule="evenodd" d="M121.338 161.377C131.763 160.812 135.587 165.532 132.813 175.537C129.696 179.661 125.709 180.882 120.85 179.199C115.312 175.52 114.091 170.719 117.187 164.795C118.471 163.472 119.854 162.332 121.338 161.377Z" fill="#FEF5EB" />
    </svg>

  );
};

export default AlertIcon;
